/**
 * Circular buffer for checklist debug logs.
 * Captured in-memory and copyable to clipboard via DebugLogOverlay.
 */

const MAX_ENTRIES = 200
const buffer: string[] = []

export function clLog(tag: string, ...args: unknown[]) {
  const ts = new Date().toISOString().slice(11, 23) // HH:mm:ss.SSS
  const msg = `[${ts}][${tag}] ${args.map(a => typeof a === "string" ? a : JSON.stringify(a)).join(" ")}`
  buffer.push(msg)
  if (buffer.length > MAX_ENTRIES) buffer.shift()
  // Also log to console for Safari Web Inspector
  console.log(`[checklist-dbg][${tag}]`, ...args)
}

export function getDebugLog(): string {
  return buffer.join("\n")
}

export function clearDebugLog() {
  buffer.length = 0
}

export function getDebugLogCount(): number {
  return buffer.length
}
